module.exports = __webpack_public_path__ + "static/img/default_image_screen.6d3f5e5f.png";